import {
    getInvoices as fetchInvoicesAPI,
    getInvoice as fetchInvoiceAPI,
    createInvoice as createInvoiceAPI,
    saveDraft as saveDraftAPI,
    updateInvoice as updateInvoiceAPI,
    deleteInvoice as deleteInvoiceAPI,
} from "../../services/invoice";
import toast from "react-hot-toast";

// Fetch all invoices
export const fetchInvoices = (query = {}) => async (dispatch, getState) => {
    const { profile } = getState();
    const userId = profile?.profile?.id;

    if (!userId) {
        console.warn("User profile not available. Cannot fetch invoices.");
        return;
    }

    dispatch({ type: "FETCH_INVOICES_REQUEST" });
    try {
        const params = {
            userId,
            ...query,
        };
        console.log(params);
        const response = await fetchInvoicesAPI(params);
        dispatch({ type: "FETCH_INVOICES_SUCCESS", payload: response.data });
    } catch (error) {
        console.error("Failed to fetch invoices!", error);
    }
};

// Fetch single invoice
export const fetchInvoice = (id) => async (dispatch, getState) => {
    const { profile } = getState();
    const userId = profile?.profile?.id;

    if (!userId) {
        console.warn("User profile not available. Cannot fetch invoice.");
        return;
    }

    dispatch({ type: "FETCH_INVOICE_REQUEST" });
    try {
        const response = await fetchInvoiceAPI(id, userId);
        dispatch({ type: "FETCH_INVOICE_SUCCESS", payload: response.data });
    } catch (error) {
        console.error("Failed to fetch invoice!", error);
    }
};

// Create a new invoice
export const createInvoice = (invoice) => async (dispatch, getState) => {
    const { profile } = getState();
    const userId = profile?.profile?.id;

    if (!userId) {
        console.warn("User profile not available. Cannot create invoice.");
        return;
    }

    try {
        const response = await createInvoiceAPI({ ...invoice, userId });
        dispatch({ type: "ADD_INVOICE_SUCCESS", payload: response.data });
        toast.success("Invoice created successfully!");
    } catch (error) {
        console.error("Failed to create invoice!", error);
        toast.error("Failed to create invoice!");
    }
};

export const saveAsDraft = (invoice) => async (dispatch, getState) => {
    const { profile } = getState();
    const userId = profile?.profile?.id;

    if (!userId) {
        console.warn("User profile not available. Cannot save draft invoice.");
        return;
    }

    try {
        const response = await saveDraftAPI({ ...invoice, userId });
        dispatch({ type: "ADD_INVOICE_SUCCESS", payload: response.data });
        toast.success("Invoice saved as draft!");
    } catch (error) {
        console.error("Failed to save invoice as draft!", error);
        toast.error("Failed to save invoice as draft!");
    }
}

// Update invoice
export const updateInvoice = (invoice) => async (dispatch, getState) => {
    const { profile } = getState();
    const userId = profile?.profile?.id;

    if (!userId) {
        console.warn("User profile not available. Cannot save draft invoice.");
        return;
    }

    try {
        const response = await updateInvoiceAPI({ ...invoice, userId });
        dispatch({ type: "UPDATE_INVOICE_SUCCESS", payload: response.data });
        toast.success("Invoice updated successfully!");
    } catch (error) {
        console.error("Failed to update invoice!", error);
        toast.error("Failed to update invoice!");
    }
};

export const markInvoiceAsPaid = (invoice) => async (dispatch, getState) => {
    const { profile } = getState();
    const userId = profile?.profile?.id;

    if (!userId) {
        console.warn("User profile not available. Cannot save draft invoice.");
        return;
    }

    try {
        const response = await updateInvoiceAPI({ ...invoice, status: "paid", userId });
        dispatch({ type: "UPDATE_INVOICE_SUCCESS", payload: response.data });
        toast.success("Invoice marked as paid!");
    } catch (error) {
        console.error("Failed to mark invoice as paid!", error);
        toast.error("Failed to mark invoice as paid!");
    }
}

// Delete invoice
export const deleteInvoice = (id) => async (dispatch) => {
    try {
        await deleteInvoiceAPI(id);
        dispatch({ type: "DELETE_INVOICE_SUCCESS", payload: id });
        toast.success("Invoice deleted successfully!");
    } catch (error) {
        console.error("Failed to delete invoice!", error);
        toast.error("Failed to delete invoice!");
    }
};
